module.exports = __webpack_public_path__ + "assets/img/warehouse_1.3215746b.svg";